import { FETCH_DYNAMIC_PAGES } from "../actions/dynamicPagesActions";

const initState = {};

const dynamicPagesReducer = (state = initState, action) => {
    if (action.type === FETCH_DYNAMIC_PAGES) {
        return {
            ...state,
            ...action.payload,
        };
    }

    return state;
};

export default dynamicPagesReducer;
